"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 16.04.2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowItemPosAttributesConverter.
 *
 * @author ZSr
 */


var WindowItemPosAttributesConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemPosAttributesConverter, _DataObjectConverter_);

  function WindowItemPosAttributesConverter() {
    _classCallCheck(this, WindowItemPosAttributesConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPosAttributesConverter).apply(this, arguments));
  }

  return WindowItemPosAttributesConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemPosAttributesConverter = WindowItemPosAttributesConverter;